import { render, staticRenderFns } from "./Smartphone.vue?vue&type=template&id=09a9cb22&"
import script from "./Smartphone.vue?vue&type=script&lang=js&"
export * from "./Smartphone.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports